import LoginModel from "models/loginModel.js";
import SelfModel from "models/selfModel.js";
import S from "session/session.js";

var instance = null;

function MySingleton() {
    if (instance !== null)
        throw new Error("Cannot instantiate more than one MySingleton, use MySingleton.getInstance()");

    this.initialize();
}

var loginModel = new LoginModel();
var selfModel = new SelfModel();

MySingleton.prototype = {
    initialize: function() {

        // summary:
        // Initializes the singleton.
        var self = this;

        this.getToken = function(loginData) {

            //Check if userInfo is already loaded
            if (S.userInfo)
                return true;

            if (!localStorage.getItem("coreEsToken")) {
                //If is not logindata undefined
                if (loginData) {
                    var data = {
                        "username": loginData.username,
                        "password": loginData.password,
                        "grant_type": "password",
                        "client_id": "coreInventEsApp",
                        "client_secret": "corePass"
                    };

                    $("#loaderContainer").show();
                    loginModel.save(data, {
                        success: function() {
                            S.token = loginModel.attributes.access_token;

                            selfModel.fetch({
                                beforeSend: self.useToken,
                                success: function() {                                    
                                    S.mainMenu = selfModel.attributes.options; //Store menu options for later recover
                                    S.instanceId = selfModel.attributes.instanceId;
                                    S.companyId = selfModel.attributes.company;
                                    S.userInfo = selfModel;
                                    self.saveToken(loginModel.attributes);

                                    S.mApp.trigger("access:pass");
                                    $("#loaderContainer").hide();
                                },
                                error: function(model, response) {

                                    $("#loaderContainer").hide();

                                    if (response.status === 401) {
                                        S.mApp.trigger("access:failuser");

                                        localStorage.removeItem("coreEsUser");
                                        localStorage.removeItem("coreEsUserId");
                                        localStorage.removeItem("coreEsToken");

                                        S.token = "";

                                    } else if (response.status === 404) {

                                        S.mApp.trigger("notify:error", {
                                            message: " - ERROR Undefined -"
                                        });

                                        localStorage.removeItem("coreEsUser");
                                        localStorage.removeItem("coreEsUserId");
                                        localStorage.removeItem("coreEsToken");

                                        S.token = "";

                                    }
                                }
                            });

                            return true;
                        },
                        error: function(model, response) {
                            if (response.status === 401) {
                                S.mApp.trigger("access:fail");
                                return false;
                            }

                            if (response.status === 404) {
                                S.mApp.trigger("notify:error", {
                                    message: "login Error"
                                });
                                return false;
                            }
                        }
                    });
                } else {
                    //It is not logindata undefined and it is not coreEsToken in localstorage
                    S.mApp.trigger("notify:loginIncomplete");
                    return false;
                }

            } else {
                S.token = localStorage.getItem("coreEsToken");

                selfModel.fetch({
                    beforeSend: self.useToken,
                    success: function() {
                        S.instanceId = parseInt(selfModel.attributes.instanceId);
                        S.companyId = parseInt(selfModel.attributes.company);
                        S.mainMenu = selfModel.attributes.options;
                        S.userInfo = selfModel;
                        S.mApp.trigger("access:pass");
                    },
                    error: function() {
                        //Si falla el token almacenado, ir a login
                        this.deleteToken();
                        window.top.location = "";
                    }.bind(this)
                });

                return true;
            }
        };

        this.deleteToken = function() {
            localStorage.removeItem("coreEsUser");
            localStorage.removeItem("coreEsUserId");
            localStorage.removeItem("coreEsToken");
        };

        this.saveToken = function(data) {
            localStorage.setItem("coreEsUser", $("#username").val());
            localStorage.removeItem("coreEsUserId", data.id);
            localStorage.setItem("coreEsToken", data.access_token);
        };

        //Function for config ajax with token
        this.useToken = function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        };
    }
};

MySingleton.getInstance = function() {
    // summary:
    // Gets an instance of the singleton. It is better to use
    if (instance === null)
        instance = new MySingleton();

    return instance;
};

export default MySingleton.getInstance();


//////////////////
// WEBPACK FOOTER
// ./app/session/token.js
// module id = 6
// module chunks = 0